<template>



  <div v-if="isLoggedIn() && order" class="mt-10 mx-auto bg-white">

    <div class="max-w-full mx-auto bg-white border border-gray-200 px-4 sm:px-8 py-10 rounded-lg">
      <fieldset>
        <div class="flex items-center justify-start space-x-2 py-4">
          <div class="w-12 h-12 bg-primary-500 text-white rounded-full flex items-center justify-center">
            {{ acronym }}
          </div>
          <div class="text-lg font-bold">{{ user.displayName() }}

            <br v-if="user.displayName() !== userContact"><span v-if="user.displayName() !== userContact"
              class="font-sm font-normal">{{ userContact }}</span>
          </div>

        </div>
        <p class="text-base  text-slate-900 py-4">
          Jesteś zalogowany jako <b>{{ user.displayName() }}</b>. Jeśli to nie Twoje konto,
          <a href="#" @click="logout" class="text-primary-500 hover:text-primary-600 text-base font-medium">
            wyloguj się
          </a> aby wybrać inne konto.


        </p>

      </fieldset>
    </div>
  </div>



  <div v-if="!isLoggedIn()"
    class="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-75 shadow-xl">

    <div v-if="step < 3">


      <div class="flex justify-center">

        <div class="w-full max-w-xl mx-auto text-left bg-white px-4 sm:px-8 py-10 rounded-xl">
          <AppBar :previousPage="closePopup" icon="close" :title="title" />
          <p class="text-small text-slate-500 py-6" v-html="subtitle"></p>

          <form @submit.prevent="(step == 1) ? checkIfUserExists() : sendAuthCode()">
            <div class="flex flex-col items-center justify-center4">
              <input type="text" v-model="login" placeholder="Adres email"
                :class="`block w-full text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-primary-500`"
                required>
              <span v-if="errorMessage" class="text-red-500 text-sm">{{ errorMessage }}</span>

              <div v-if="step==2 && localAgreements?.length > 0"
                class="flex items-start text-base font-light text-gray-900 rounded mt-6 w-full">
                <div class="w-full">
                  <div v-for="(agreement, index) in localAgreements" :key="agreement.id" class="mb-2 last:mb-0">
                    <AgreementCheckBox :agreement="agreement" v-model="localAgreements[index].acceptance"
                      :error="errors[index] || ''" />
                  </div>
                </div>
              </div>

              <button type="submit"
                class="primary-button button-md mt-8 w-full max-w-xs disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
                :disabled="!canProceed() || isVerifying">
                Wyślij
              </button>
            </div>

          </form>

        </div>
      </div>



    </div>


    <div v-else-if="step === 3">
      <div class="flex justify-center">
        <div class="max-w-lg mx-auto text-center bg-white px-4 sm:px-8 py-10 rounded-xl">
          <AppBar :previousPage="onReset" icon="close" :title="verifcationTitle" />
          <p class="text-small text-slate-500 py-6" v-html="verifcationSubtitle"></p>


          <form @submit.prevent="verifyCode">
            <div class="flex items-center justify-center gap-3">
              <input v-for="(digit, index) in otp" :key="index" :ref="`input${index}`" v-model="otp[index]" type="text"
                :class="`w-14 h-14 text-center text-2xl font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 rounded`"
                pattern="\d*" maxlength="1" @keydown="handleKeyDown($event, index)" @input="handleInput(index)"
                @focus="handleFocus" @paste="handlePaste" />
            </div>
            <span v-if="errorMessage" class="text-red-500 text-sm">{{ errorMessage }}</span>
            <div class="max-w-xs mx-auto mt-4">
              <button type="submit"
                class="primary-button button-md w-full max-w-xs disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
                :disabled="isVerifying">
                Weryfikacja kodu
              </button>
            </div>
          </form>

          <div class="text-sm text-slate-500 mt-4">
            Nie otrzymałeś kodu?
            <a href="#0" class="font-medium text-primary-500 hover:text-primary-500" @click.prevent="(() => {
              const last = Number(resendTimestamp || 0);
              const now = Date.now();
              const wait = 60 * 1000; // 1 minute
              if (now - last < wait) {
                const sec = Math.ceil((wait - (now - last)) / 1000);
                this.errorMessage = `Aby uniknąć błędów autoryzacji, sprawdź skrzynkę odbiorczą i folder spam. Ponowne wysłanie kodu będzie możliwe za ${sec}s.`;
                return;
              }
          
              this.resendTimestamp = Date.now();
              resendCode();
            })()">
              Wyślij ponownie
            </a>
          </div>
        </div>
      </div>
    </div>


    <div v-else-if="step === 3" class="flex flex-col items-center justify-center">

      <div class="flex flex-col items-center max-w-md mx-auto text-center bg-white px-4 sm:px-8 py-10 rounded-xl">
        <CheckCircleIcon class="w-16 h-16 text-green-500 mb-4" />
        <p class="text-sm text-gray-700">Zostałeś pomyślnie zalogowany.</p>
        <button @click="closePopup"
          class="mt-4 w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600">Zamknij</button>
      </div>

    </div>

  </div>

</template>

<script>
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import AppBar from './AppBar.vue';
import AgreementCheckBox from './AgreementCheckBox.vue';
import rpAPI from '@shared/service/rpAPI.js';
import Globals from '@shared/model/Globals.js';


export default {

  name: 'AuthCode',
  props: {
    title: {
      type: String,
      default: 'Potwierdź dane kontaktowe'
    },
    subtitle: {
      type: String,
      default: 'Podaj adres e-mail. Wyślemy na niego kod, aby potwierdzić Twoją tożsamość i dokończyć proces.'
    },

    agreements: {
      type: Array,
      default: () => []
    },

    order: {
      type: Object,
      default: null
    },

    onNext: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
  },
  async mounted() {
    if (!this.localAgreements || this.localAgreements.length === 0) {
      try {
        this.localAgreements = await rpAPI.getAgreements('signup');
      } catch (err) {
        console.warn('Failed to load signup agreements in AuthCode:', err);
      }
    }
    if (rpAPI.isLoggedIn()) {
      await this.onSuccess();
    }
  },
  watch: {
    agreements: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.localAgreements = [...newVal];
        }
      },
      deep: true,
    }
  },
  components: {
    CheckCircleIcon,
    AppBar,
    AgreementCheckBox,
  },
  data() {
    return {
      verifyUserId: null,
      isVerifying: false,
      showPopup: false,
      step: 1,
      emailOrPhoneOrId: '', // email, phone, or ID used for verification
      login: '',
      email: '',
      phone: '',
      authCode: '',
      errorMessage: '',
      errors: [],
      localAgreements: (this.agreements && this.agreements.length > 0) ? [...this.agreements] : [],
      resendTimestamp: Date.now(),
      verifcationTitle: 'Mobile Phone Verification',
      verifcationSubtitle: 'Enter the 5-digit verification code that was sent to your phone number.',
      otp: Array(5).fill(''), // Array to hold the 4 digits of the code
    }
  },
  computed: {
    user() {
      return rpAPI.user;
    },
    acronym() {
      
      return  rpAPI.user.initials();
    },

    isTemporaryEmail() {
      return this.user.isTemporaryEmail();
    },

    userContact() {
      if (this.user && this.user.email && !this.isTemporaryEmail) {
        return this.user.email;
      } else if (this.user && this.user.phone) {
        return this.formatPhone(this.user.phone);
      }
      return '';
    },
    isPhoneDisabled() {
      return rpAPI.usePhoneAuth;
    },
  },
  methods: {
    /**
     * Persists the current Directus authentication token to a browser cookie.
     * 
     * This method saves the Directus token as a serialized JSON value in a cookie
     * that can be read by servers within the shared cookie domain for authentication purposes.
     * 
     * The cookie is configured with:
     * - Secure flag: Only transmitted over HTTPS
     * - SameSite=Lax: Protected against CSRF attacks
     * - Shared domain: Accessible across the specified domain
     * 
     * @returns {void} Returns early if no Directus token is available
     * 
     * @note The `getSharedCookieDomain()` method must be defined to determine
     * the appropriate domain for cookie sharing across subdomains.
     */
    getSharedCookieDomain() {
      const host = String(window.location.hostname || '').trim().toLowerCase();
      const mainDomain = String(Globals.EMAIL_DOMAIN || '').trim().toLowerCase();

      // If app is hosted on the main domain (or subdomain), share cookie for that domain.
      if (mainDomain && (host === mainDomain || host.endsWith('.' + mainDomain))) {
        return mainDomain;
      }

      // In local/dev environments, do not set Domain=... (browsers often reject it).
      if (!host || host === 'localhost' || /^[0-9.]+$/.test(host)) {
        return null;
      }

      // Fallback: use last 2 labels (works for most domains).
      const parts = host.split('.').slice(-2);
      return parts.join('.');
    },

    persistSession() {

      // save directus token to cookie for EMAIL_DOMAIN servers to read and authenticate the user
      if (!rpAPI.token) return;
      const value = encodeURIComponent(JSON.stringify(rpAPI.token));
      const secure = window.location?.protocol === 'https:';
      const domain = this.getSharedCookieDomain();

      let cookie = `reservepro_session=${value}; Path=/; SameSite=Lax`;
      if (domain) cookie += `; Domain=${domain}`;
      if (secure) cookie += '; Secure';
      document.cookie = cookie;

      //console.log('Persisted session to cookie:', document.cookie);
    },
    clearSession() {
      const secure = window.location?.protocol === 'https:';
      const domain = this.getSharedCookieDomain();
      let cookie = 'reservepro_session=; Path=/; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
      if (domain) cookie += `; Domain=${domain}`;
      if (secure) cookie += '; Secure';
      document.cookie = cookie;
      //console.log('Cleared session cookie:', document.cookie);
    },

    handleLogout() {
      this.clearSession();
      rpAPI.logout();
      this.onCancel();
    },

    hasAcceptedAllAgreements() {
      if (!this.localAgreements || this.localAgreements.length === 0) return true; // No agreements to accept

      return this.localAgreements.every((agreement, index) => {
        if (this.localAgreements[index].required) {
          return agreement.acceptance === 'TAK' || agreement.acceptance === true;
        }
        return true; // If not required, always true
      });

    },

    canProceed() {
      return (this.step==1 && this.login.trim() !== '')  || (this.step==2 && this.hasAcceptedAllAgreements());
    },

    formatPhone(phone) {
      if (!phone) return '';
      // Format phone number to +48 123 456 789
      const sanitizedPhone = phone.replace(/\D/g, ''); // Remove non-digit characters
      if (sanitizedPhone.length === 9) {
        return `+48 ${sanitizedPhone.slice(0, 3)} ${sanitizedPhone.slice(3, 6)} ${sanitizedPhone.slice(6)}`;
      } else if (sanitizedPhone.length > 9) {
        return `+${sanitizedPhone.slice(0, sanitizedPhone.length - 9)} ${sanitizedPhone.slice(-9, -6)} ${sanitizedPhone.slice(-6, -3)} ${sanitizedPhone.slice(-3)}`;
      }
      return phone;
    },
    isLoggedIn() {
      return rpAPI.isLoggedIn();
    },
    onReset() {
      this.step = 1;
      this.errorMessage = '';
      this.otp = Array(5).fill('');
    },
    validateLogin() {
      const directusUserIdPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
      if (directusUserIdPattern.test(this.login)) {
        return 'directus';
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phonePattern = /^\+?[1-9]\d{1,14}$/; // E.164 international phone number format
      this.login = this.login.trim().replace(/\s/g, '').replace(/^00/, '+');

      if (emailPattern.test(this.login)) {
        return 'email';
      } else if (phonePattern.test(this.login)) {
        return 'phone';
      } else {
        return null;
      }
    },

    async checkIfUserExists() {
      const loginType = this.validateLogin();
      if (!loginType) {
        this.errorMessage = 'Proszę wprowadzić prawidłowy adres e-mail lub numer telefonu.';
        return;
      }
      try {
        let exists = false;
        if (loginType === 'email') {
          exists = await rpAPI.checkIfEmailExist(this.login, 0);
        } else if (loginType === 'phone') {
          exists = await rpAPI.checkIfPhoneExist(this.login, 0);
        } else if (loginType === 'directus') {
          exists = await rpAPI.checkIfUserIdExist(this.login, 0);
        }
       
        if (!exists && this.localAgreements?.length > 0) {
          this.step = 2;
        } else {
          this.errorMessage = '';
          this.sendAuthCode();
        }
      } catch (error) {
        console.log(error);
        this.errorMessage = error.message || 'An unknown error occurred';
      }
    },

    async sendAuthCode() {

      const loginType = this.validateLogin();
      if (!loginType) {
        this.errorMessage = 'Proszę wprowadzić prawidłowy adres e-mail lub numer telefonu.';
        return;
      }
      this.emailOrPhoneOrId = this.login;


      if (loginType === 'email') {
        this.verifcationTitle = 'Weryfikacja adresu e-mail';
        this.verifcationSubtitle = `Wprowadź 5-cyfrowy kod weryfikacyjny, który został wysłany na Twój adres e-mail <b>${this.login}</b>.`;
        this.email = this.login;
      } else {
        // check prefix if given, if not add +48
        if (this.login.length === 9) {
          this.phone = '+48' + this.login;
        } else {
          this.phone = this.login.startsWith('+') ? this.login : '+' + this.login;
        }

        this.verifcationTitle = 'Weryfikacja telefonu komórkowego';
        // format phone number
        const formatPhone = this.phone.replace(/(\+\d{1,3})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
        this.verifcationSubtitle = `Wprowadź 5-cyfrowy kod weryfikacyjny, który został wysłany na Twój numer telefonu <br> <b>${formatPhone}</b>`;


      }

      this.errorMessage = '';


      try {
        if (loginType == 'directus') {
          this.showPopup = false;
          await rpAPI.loginWithDirectusUserId(this.login);
          this.showPopup = false;
          await this.onSuccess();
          return;
        } else {
          this.email = this.email?.toLowerCase() || null;
          this.phone = this.phone?.toLowerCase() || null;
          this.verifyUserId = await rpAPI.initAuthWithCode(this.email, this.phone);
        }
        this.step = 3;
      }
      catch (error) {
        console.log(error);
        this.errorMessage = error.message || 'An unknown error occurred';
      };
    },
    async onSuccess() {
      this.errorMessage = '';
      this.otp = Array(5).fill('');
      if (this.order && typeof this.order.setCustomer === 'function') {
        if (!rpAPI.user.isInitialized() && typeof rpAPI.user.initProfiles === 'function') {
          await rpAPI.user.initProfiles();
        }
        this.order.setCustomer(rpAPI.user);
      }
    
      this.persistSession();
      this.onNext();
    },

    async verifyCode(event) {
      event.preventDefault();
      if (this.isVerifying) return; // Prevent multiple submissions
      this.isVerifying = true;

      const code = this.otp.join('');
      try {
        await rpAPI.verifyAuthCode(code, this.verifyUserId);
        this.showPopup = false;
        await this.onSuccess();
      }
      catch (error) {
        this.errorMessage = error.message || 'An unknown error occurred';
      }
      finally {
        this.isVerifying = false;
      }
    },
    async resendCode() {
      if (this.isVerifying) return; // Prevent multiple submissions
      try {
        this.resendTimestamp = Date.now();
        await rpAPI.resendCode(this.verifyUserId, this.phone, this.email);
        this.errorMessage = 'Kod został ponownie wysłany.';
        this.resentTimeout = setTimeout(() => {
          this.errorMessage = '';
        }, 12000);
      } catch (error) {
        this.errorMessage = error.message || 'An unknown error occurred';
      }

      console.log('Resend code');
    },
    handleKeyDown(event, index) {
      if (!/^[0-9]{1}$/.test(event.key) && !['Backspace', 'Delete', 'Tab'].includes(event.key)) {
        event.preventDefault();
      }

      if (['Backspace', 'Delete'].includes(event.key) && index > 0) {
        this.otp[index] = '';
        this.$refs[`input${index - 1}`][0]?.focus();
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const text = event.clipboardData.getData('text/plain');
      const digits = text.replace(/\D/g, '').split('').slice(0, 5);
      if (digits.length > 0) {
        this.otp = Array(5).fill('');
        digits.forEach((digit, index) => {
          this.otp[index] = digit;
        });
        this.$nextTick(() => {
          const focusIndex = Math.min(digits.length, this.otp.length - 1);
          this.$refs[`input${focusIndex}`][0]?.focus();
        });
      }
    },
    handleInput(index) {

      if (this.otp[index] && index < this.otp.length - 1) {
        this.$nextTick(() => {
          this.$refs[`input${index + 1}`][0]?.focus();
        });
      }

      // Additional logic to handle input event
      const text = this.otp.join('');
      const match = text.match(/[0-9]{5}/);
      if (match && /^[0-9]{5}$/.test(match[0])) {
        const digits = match[0].split('');
        this.otp = digits;
      }
    },
    handleFocus(event) {
      event.target.select();
    },
    logout() {
      rpAPI.logout();
      this.clearSession();
      this.showPopup = false;
      this.onCancel();
      console.log('Logout');
    },
    closePopup() {
      rpAPI.logout();
      this.clearSession();
      this.showPopup = false;
      this.onCancel();
      console.log('closePopup');
    }
  },

};
</script>
